import React, { useEffect } from 'react';
import { Redirect, Route, Router, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import Alert from 'react-s-alert';
import { connect, useSelector } from 'react-redux';
import Styles from '../themes/style.module.scss';
import Login from './mainComponents/Login';
import MapContainer from './mainComponents/MapContainer';
import { DentistList } from './mainComponents/UsersList/DentistList/DentistList';
import { DSOOfficeList } from './mainComponents/UsersList/DSOOfficeList/DSOOfficeList';
import { UnfinishedUserList } from './mainComponents/UsersList/UnfinishedUserList/UnfinishedUserList';
import { ProfessionalList } from './mainComponents/UsersList/ProfessionalList/ProfessionalList';
import { Licenses } from './mainComponents/Licenses/Licenses';
import PostPPJob from './mainComponents/Job/PP/PostPPJob';

import { JobList } from './mainComponents/JobList/JobList';

import Dashboard from './commonComponents/Dashboard';
import Profile from './mainComponents/User/Profile';
import JobDetails from './mainComponents/Job/JobDetails';
import JobCreateComponent from './mainComponents/Job/JobCreateComponent';
import SMSCampaign from './mainComponents/SMSCampaign';
import { ProPerks } from './mainComponents/ProPerks/ProPerks';
import TableauBoard from './mainComponents/TableauBoard';

import history from '../history';

import 'bootstrap/dist/css/bootstrap.min.css';
import { refresh } from '../actions/authActions';
import { createLoadingSelector } from '../apis/selectors';
import PPJobDetails from './mainComponents/Job/PP/PPJobDetails';
import ChatMessages from './mainComponents/ChatMessages';
import { MultidayList } from './mainComponents/MultidayList';
import { MultidayJobs } from './mainComponents/Job/Multiday/MultidayJobs';
import PostMultiday from './mainComponents/Job/Multiday/PostMultiday';
import { ReferralList } from './mainComponents/ReferralList/ReferralList';
import SSOCallbackHandler from './mainComponents/SSOCallbackHandler';
import { getShouldEnablePermanentJobV2, growthbook, shouldUseDsoStructure } from '../growthbook';
import { PermanentJobList } from './mainComponents/PermanentJobList/PermanentJobList';
import { DsosList } from './mainComponents/UsersList/DsosList/DsosList';
import { DsoGroupDetails } from './mainComponents/DsoGroupDetails/DsoGroupDetails';
import { StaffDetails } from './mainComponents/StaffDetails/StaffDetails';
import { OfficeAdminList } from './mainComponents/UsersList/OfficeAdminList/OfficeAdminList';
import { PermanentJobListV2 } from './mainComponents/PermanentJobV2/PermanentJobListV2';
import { PostPermanentJobV2 } from './mainComponents/PermanentJobV2/PostPermanentJobV2';
import { PermanentJobDetailV2 } from './mainComponents/PermanentJobV2/PermanentJobDetailV2';
import { CreateOnsiteInterview } from './mainComponents/PermanentJobV2/CreateOnsiteInterview';
import { useInitialLoading } from '../hooks/useInitialLoading';

const homePath = process.env.PUBLIC_URL;
const tableauBoardGraph =
  'https://prod-useast-a.online.tableau.com/t/tempmeecom/views/DashboardData/Dashboard1/6bf5bb7a-5b04-456b-9d84-e1fb49f59477/0d859810-89b3-4506-86c6-3eeb724ffb0e';
const tableauBoardList =
  'https://prod-useast-a.online.tableau.com/t/tempmeecom/views/Dashboard3_0/Sheet36';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ready: false,
    };
  }

  render() {
    const { isSignedIn, isSSOLoading, isInitialLoading } = this.props;

    if (isSSOLoading || isInitialLoading) {
      return (
        <div className={Styles.screenView}>
          <div className={Styles.ModalTransparent}>
            <div className="spinner-border text-info d-flex justify-content-center bg-transparent" />
          </div>
        </div>
      );
    }

    if (!isSignedIn) {
      return (
        <Router basename={homePath} history={history}>
          <Route strict path="/" component={Login} />
          <Route strict path="/auth/google" component={SSOCallbackHandler} />
          <Redirect to="/" />
          <div>
            <Alert stack={{ limit: 3 }} />
          </div>
        </Router>
      );
    }

    return (
      <Router basename={homePath} history={history}>
        <Route path="/" component={Dashboard} />
        <Switch>
          <Route path="/dentist" component={DentistList} />
          <Route path="/dso" component={DSOOfficeList} />
          <Route path="/hygienist" component={ProfessionalList} />
          <Route path="/licenses" component={Licenses} />
          <Route path="/unfinished" component={UnfinishedUserList} />
          {shouldUseDsoStructure() && <Route path="/office-staff" component={OfficeAdminList} />}
          {shouldUseDsoStructure() && <Route path="/dsos" exact component={DsosList} />}
          {shouldUseDsoStructure() && <Route path="/dsos/:id/:currentTab" component={DsoGroupDetails} />}
          {shouldUseDsoStructure() && <Route path="/staff/:id" component={StaffDetails} />}
          <Route path="/jobs" component={JobList} />
          <Route path="/pp-job/:id" component={PPJobDetails} />
          <Route path="/pp-jobs" exact component={PermanentJobList} />
          {getShouldEnablePermanentJobV2() && <Route path="/permanent-jobs" exact component={PermanentJobListV2} />}
          {getShouldEnablePermanentJobV2() && <Route path="/permanent-job/post" component={PostPermanentJobV2} />}
          {getShouldEnablePermanentJobV2() && <Route path="/permanent-job/job/:jobId/create-onsite-interview" component={CreateOnsiteInterview} />}
          {getShouldEnablePermanentJobV2() && <Route path="/permanent-job/office/:officeId/job/:jobId/:currentTab" component={PermanentJobDetailV2} />}
          {getShouldEnablePermanentJobV2() && <Route path="/permanent-job/office/:officeId/job/:jobId" component={PermanentJobDetailV2} />}
          <Route path="/user/:profileType/:id/:currentTab" component={Profile} />
          <Route path="/user/:profileType/:id" component={Profile} />
          <Route path="/job/:id/:currentTab" component={JobDetails} />
          <Route path="/job/:id" component={JobDetails} />
          <Route path="/pp-post-job" component={PostPPJob} />
          <Route path="/jobcreate" component={JobCreateComponent} />
          <Route path="/sms" component={SMSCampaign} />
          <Route path="/properks" component={ProPerks} />
          <Route path="/messages" exact component={ChatMessages} />
          <Route path="/messages/:id" component={(props) => <ChatMessages {...props} />} />
          <Route path="/multiday/post" exact component={PostMultiday} />
          <Route path="/multiday/:multidayId" component={MultidayJobs} />
          <Route path="/multiday" exact component={MultidayList} />
          <Route path="/referral" component={ReferralList} />
          <Route
            path="/dash-metrics"
            exact
            component={() => <TableauBoard url={tableauBoardGraph} />}
          />
          <Route
            path="/dash-list"
            exact
            component={() => <TableauBoard url={tableauBoardList} />}
          />
          <Route path="/" exact component={MapContainer} />
          <Route path="*">
            <Redirect to="/" />
          </Route>
        </Switch>
        <div>
          <Alert stack={{ limit: 3 }} />
        </div>
      </Router>
    );
  }
}

App.protoTypes = {
  isSignedIn: PropTypes.bool,
  refresh: PropTypes.func,
};

const refreshLoadingSelector = createLoadingSelector(['AUTH_REFRESH']);
const ssoLoadingSelector = createLoadingSelector(['AUTH_SIGN_IN_GOOGLE', 'AUTH_SIGN_IN']);
const mapStateToProps = (store) => ({
  isRefeshLoading: refreshLoadingSelector(store),
  isSSOLoading: ssoLoadingSelector(store),
  isSignedIn: !!store.auth.access_token,
  adminUser: store.users.adminUser,
});

function AppWithHook(Component) {
  // eslint-disable-next-line react/function-component-definition
  return function WrappedComponent(props) {
    const { isLoading } = useInitialLoading();
    const { adminUser } = useSelector((state) => state.users);

    useEffect(() => {
      if (adminUser) {
        growthbook.setAttributes({
          ...growthbook.getAttributes(),
          id: adminUser.id,
        });
      }
    }, [adminUser]);

    return <Component {...props} isInitialLoading={isLoading} />;
  };
}

export default connect(mapStateToProps, { refresh })(AppWithHook(App));
